module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionCwcjMobile.386ad2a6.png";